import { Box, Container, Typography } from "@mui/material";

import { Subtitle1Text } from "components/shared/Typography";
import { colors } from "theme";

export const TopBanner = () => (
  <Box component="section" bgcolor={colors.white}>
    <Container>
      <Box
        display="flex"
        flexDirection="column"
        py={{ xs: 3, md: 4, lg: 5 }}
        gap="16px"
        position="relative"
      >
        <Typography variant="h1">
          <Box
            fontSize={{ xs: 22, sm: 32 }}
            lineHeight={{ xs: "28px", sm: "42px" }}
            letterSpacing={0.25}
          >
            Welcome to Assay Marketplace
          </Box>
        </Typography>
        <Subtitle1Text>
          We want you to find the right contact person as soon as possible.
          Thank you for your interest. We are looking forward to your contact
          and hope to be able to help you.
        </Subtitle1Text>
      </Box>
    </Container>
  </Box>
);
